export default {"src":"/_next/static/media/Management.6f75b1ac.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};